import type { ReactNode } from "react"

/**
 * La fila de indicadores de una pestaña: la rejilla de siempre (1 → 2 → 4 columnas) y sus
 * tres estados.
 *
 * ⚠ **Cargando no pinta nada, y un error se dice sin tumbar la pestaña.** La lista de abajo
 * es lo que se vino a usar: los indicadores la resumen, y si fallan la lista sigue al día.
 * Es la misma frase que en la bandeja de órdenes.
 */
export function FilaKpi({
  cargando,
  error,
  children,
  className = "",
}: {
  cargando: boolean
  error: boolean
  children: ReactNode
  className?: string
}) {
  if (error) {
    return (
      <p className={`text-sm ${className}`} style={{ color: "var(--fg-muted)" }}>
        No se pudieron cargar los indicadores; la lista de abajo sigue al día.
      </p>
    )
  }
  if (cargando) return null
  return (
    <section
      aria-label="Indicadores"
      className={`grid gap-3 sm:grid-cols-2 xl:grid-cols-4 ${className}`}
    >
      {children}
    </section>
  )
}
